import { Flex, HStack, Text } from '@cad-arc';
import React from 'react';

export function TabSubtitle(props: {
    children: React.ReactNode;
    subtitleTrailingNode?: React.ReactNode;
    rightContent?: React.ReactNode;
}): React.ReactElement {
    return (
        <Flex
            borderBottomWidth="1px"
            borderBottomColor="border.default"
            mb={1}
            pb={2}
            w="100%"
            alignItems="center"
            justifyContent="space-between"
        >
            <HStack alignItems="center">
                <Text variant="headingSm" color="text.placeholder">
                    {props.children}
                </Text>
                {props.subtitleTrailingNode ? props.subtitleTrailingNode : <></>}
            </HStack>
            {props.rightContent ? props.rightContent : <></>}
        </Flex>
    );
}
